"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getUpcyclingInverse = getUpcyclingInverse;
exports.upcyclingPricingInverse = void 0;
var _commonPricings = require("./commonPricings");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *** Version: 12 ***

/* eslint max-len: 0, object-curly-newline: 0 */

var variousPricingsName = 'Éléments de customisation';
var rawUpcyclingPricing = [{
  name: 'Manteau & veste',
  slug: 'mant',
  types: undefined,
  categories: [{
    name: 'Manches / Épaules',
    slug: 'sleeves_upcycling',
    items: [{
      name: 'Ajout ornements manches',
      prices: {
        DEFAULT: {
          min: 50,
          max: 60
        }
      },
      id: '12.mant-upc-1'
    }, {
      name: 'Création de manches',
      prices: {
        DEFAULT: {
          min: 100,
          max: 130
        }
      },
      liningPrices: {
        DEFAULT: 25
      },
      id: '12.mant-upc-2'
    }, {
      name: 'Structuration des épaules',
      prices: {
        DEFAULT: {
          min: 85,
          max: 100
        }
      },
      liningPrices: {
        DEFAULT: 25
      },
      id: '12.mant-upc-3'
    }]
  }, {
    name: 'Col',
    slug: 'col_upcycling',
    items: [{
      name: 'Revue du design de l’encolure',
      prices: {
        DEFAULT: {
          min: 95,
          max: 110
        }
      },
      id: '12.mant-upc-4'
    }, {
      name: 'Création de col',
      prices: {
        DEFAULT: {
          min: 100,
          max: 140
        }
      },
      id: '12.mant-upc-5'
    }]
  }, {
    name: 'Haut global',
    slug: 'mant_upcycling',
    items: [{
      name: 'Cintrer d’une taille intégralement ou plus',
      prices: {
        DEFAULT: {
          min: 90,
          max: 130
        }
      },
      liningPrices: {
        DEFAULT: 40
      },
      id: '12.mant-upc-6'
    }, {
      name: 'Rigidification : donner de la tenue',
      prices: {
        DEFAULT: {
          min: 60,
          max: 80
        }
      },
      liningPrices: {
        DEFAULT: 15
      },
      id: '12.mant-upc-7'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'mant',
    name: variousPricingsName,
    categorySlug: 'upc',
    type: 'COMPLEX',
    minIndex: 7,
    slug: 'divers_upcycling'
  })]
}, {
  name: 'Haut',
  slug: 'haut',
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Habillé'
  }],
  categories: [{
    name: 'Bustier / Taille',
    slug: 'bustier_upcycling',
    items: [{
      name: 'Ouverture dos',
      prices: {
        SIMPLE: {
          min: 15,
          max: 20
        },
        COMPLEX: {
          min: 20,
          max: 30
        }
      },
      liningPrices: {
        SIMPLE: 6,
        COMPLEX: 8
      },
      id: '12.haut-upc-1'
    }, {
      name: 'Décolleté',
      prices: {
        SIMPLE: {
          min: 50,
          max: 65
        },
        COMPLEX: {
          min: 65,
          max: 80
        }
      },
      liningPrices: {
        SIMPLE: 8,
        COMPLEX: 10
      },
      id: '12.haut-upc-2'
    }]
  }, {
    name: 'Manches / Épaules',
    slug: 'sleeves_upcycling',
    items: [{
      name: 'Ajout ornements manches',
      prices: {
        SIMPLE: {
          min: 40,
          max: 50
        },
        COMPLEX: {
          min: 50,
          max: 60
        }
      },
      id: '12.haut-upc-3'
    }, {
      name: 'Création de manches',
      prices: {
        SIMPLE: {
          min: 80,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 130
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.haut-upc-4'
    }, {
      name: 'Structuration des épaules',
      prices: {
        SIMPLE: {
          min: 70,
          max: 85
        },
        COMPLEX: {
          min: 85,
          max: 100
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.haut-upc-5'
    }]
  }, {
    name: 'Col',
    slug: 'col_upcycling',
    items: [{
      name: 'Revue du design de l’encolure',
      prices: {
        SIMPLE: {
          min: 80,
          max: 95
        },
        COMPLEX: {
          min: 95,
          max: 110
        }
      },
      id: '12.haut-upc-6'
    }, {
      name: 'Création de col',
      prices: {
        SIMPLE: {
          min: 70,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 140
        }
      },
      id: '12.haut-upc-7'
    }]
  }, {
    name: 'Haut global',
    slug: 'haut_upcycling',
    items: [{
      name: 'Cintrer d’une taille intégralement ou plus',
      prices: {
        SIMPLE: {
          min: 60,
          max: 90
        },
        COMPLEX: {
          min: 90,
          max: 130
        }
      },
      liningPrices: {
        SIMPLE: 25,
        COMPLEX: 40
      },
      id: '12.haut-upc-8'
    }, {
      name: 'Rigidification : donner de la tenue',
      prices: {
        SIMPLE: {
          min: 40,
          max: 60
        },
        COMPLEX: {
          min: 60,
          max: 80
        }
      },
      liningPrices: {
        SIMPLE: 10,
        COMPLEX: 15
      },
      id: '12.haut-upc-9'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'haut',
    name: variousPricingsName,
    categorySlug: 'upc',
    minIndex: 9,
    slug: 'divers_upcycling'
  })]
}, {
  name: 'Pantalon',
  slug: 'pant',
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Tailleur'
  }],
  categories: [{
    name: 'Structure globale',
    slug: 'structure_upcycling',
    items: [{
      name: 'Cintrer de plus d’une taille',
      prices: {
        SIMPLE: {
          min: 60,
          max: 80
        },
        COMPLEX: {
          min: 80,
          max: 110
        }
      },
      liningPrices: {
        SIMPLE: 20,
        COMPLEX: 30
      },
      id: '12.pant-upc-1'
    }, {
      name: 'Rigidification : donner de la tenue',
      prices: {
        SIMPLE: {
          min: 40,
          max: 60
        },
        COMPLEX: {
          min: 60,
          max: 80
        }
      },
      liningPrices: {
        SIMPLE: 10,
        COMPLEX: 15
      },
      id: '12.pant-upc-2'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'pant',
    name: variousPricingsName,
    categorySlug: 'upc',
    minIndex: 3,
    slug: 'divers_upcycling'
  })]
}, {
  name: 'Jupe',
  slug: 'jupe',
  types: [{
    slug: 'SIMPLE',
    name: 'Simple'
  }, {
    slug: 'COMPLEX',
    name: 'Habillée'
  }],
  categories: [{
    name: 'Jupe globale',
    slug: 'jupe_upcycling',
    items: [{
      name: 'Transformation > Pantalon',
      prices: {
        SIMPLE: {
          min: 60,
          max: 90
        },
        COMPLEX: {
          min: 100,
          max: 150
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.jupe-upc-1'
    }, {
      name: 'Cintrer d’une taille intégralement ou plus',
      prices: {
        SIMPLE: {
          min: 60,
          max: 90
        },
        COMPLEX: {
          min: 90,
          max: 130
        }
      },
      liningPrices: {
        SIMPLE: 25,
        COMPLEX: 40
      },
      id: '12.jupe-upc-2'
    }, {
      name: 'Rigidification : donner de la tenue',
      prices: {
        SIMPLE: {
          min: 40,
          max: 60
        },
        COMPLEX: {
          min: 60,
          max: 80
        }
      },
      liningPrices: {
        SIMPLE: 10,
        COMPLEX: 15
      },
      id: '12.jupe-upc-3'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'jupe',
    name: variousPricingsName,
    categorySlug: 'upc',
    minIndex: 4,
    slug: 'divers_upcycling'
  })]
}, {
  name: 'Robe',
  slug: 'robe',
  types: [{
    slug: 'SIMPLE',
    name: 'Petite robe classique'
  }, {
    slug: 'COMPLEX',
    name: 'Robe de soirée'
  }],
  categories: [{
    name: 'Bustier / Taille',
    slug: 'bustier_upcycling',
    items: [{
      name: 'Ouverture dos',
      prices: {
        SIMPLE: {
          min: 15,
          max: 20
        },
        COMPLEX: {
          min: 20,
          max: 30
        }
      },
      liningPrices: {
        SIMPLE: 6,
        COMPLEX: 8
      },
      id: '12.robe-upc-1'
    }, {
      name: 'Décolleté',
      prices: {
        SIMPLE: {
          min: 50,
          max: 65
        },
        COMPLEX: {
          min: 65,
          max: 80
        }
      },
      liningPrices: {
        SIMPLE: 8,
        COMPLEX: 10
      },
      id: '12.robe-upc-2'
    }, {
      name: 'Séparation haut / bas',
      prices: {
        SIMPLE: {
          min: 50,
          max: 60
        },
        COMPLEX: {
          min: 60,
          max: 70
        }
      },
      liningPrices: {
        SIMPLE: 8,
        COMPLEX: 10
      },
      id: '12.robe-upc-3'
    }]
  }, {
    name: 'Manches / Épaules',
    slug: 'sleeves_upcycling',
    items: [{
      name: 'Ajout ornements manches',
      prices: {
        SIMPLE: {
          min: 40,
          max: 50
        },
        COMPLEX: {
          min: 50,
          max: 60
        }
      },
      id: '12.robe-upc-4'
    }, {
      name: 'Création de manches',
      prices: {
        SIMPLE: {
          min: 80,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 130
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.robe-upc-5'
    }, {
      name: 'Structuration des épaules',
      prices: {
        SIMPLE: {
          min: 70,
          max: 85
        },
        COMPLEX: {
          min: 85,
          max: 100
        }
      },
      liningPrices: {
        SIMPLE: 25,
        COMPLEX: 25
      },
      id: '12.robe-upc-6'
    }]
  }, {
    name: 'Col',
    slug: 'col_upcycling',
    items: [{
      name: 'Revue du design de l’encolure',
      prices: {
        SIMPLE: {
          min: 80,
          max: 95
        },
        COMPLEX: {
          min: 95,
          max: 110
        }
      },
      id: '12.robe-upc-7'
    }, {
      name: 'Création de col',
      prices: {
        SIMPLE: {
          min: 70,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 140
        }
      },
      id: '12.robe-upc-8'
    }]
  }, {
    name: 'Bas de robe / jupe',
    slug: 'bottom_upcycling',
    items: [{
      name: 'Transfo > Pantalon',
      prices: {
        SIMPLE: {
          min: 60,
          max: 90
        },
        COMPLEX: {
          min: 100,
          max: 150
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.robe-upc-9'
    }, {
      ref: '12.robe-upc-3'
    }]
  }, {
    name: 'Robe globale',
    slug: 'robe_upcycling',
    items: [{
      name: 'Cintrer d’une taille intégralement ou plus',
      prices: {
        SIMPLE: {
          min: 90,
          max: 120
        },
        COMPLEX: {
          min: 130,
          max: 180
        }
      },
      liningPrices: {
        SIMPLE: 30,
        COMPLEX: 50
      },
      id: '12.robe-upc-10'
    }, {
      name: 'Rigidification : donner de la tenue',
      prices: {
        SIMPLE: {
          min: 50,
          max: 70
        },
        COMPLEX: {
          min: 60,
          max: 70
        }
      },
      liningPrices: {
        SIMPLE: 10,
        COMPLEX: 15
      },
      id: '12.robe-upc-11'
    }, {
      ref: '12.robe-upc-3'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'robe',
    name: variousPricingsName,
    categorySlug: 'upc',
    minIndex: 11,
    slug: 'divers_upcycling'
  })]
}, {
  name: 'Robe de mariée',
  slug: 'mari',
  types: undefined,
  categories: [{
    name: 'Bustier / Taille',
    slug: 'bustier_upcycling',
    items: [{
      name: 'Ouverture dos',
      prices: {
        DEFAULT: {
          min: 50,
          max: 80
        }
      },
      liningPrices: {
        DEFAULT: 15
      },
      id: '12.mari-upc-1'
    }, {
      name: 'Décolleté',
      prices: {
        DEFAULT: {
          min: 110,
          max: 140
        }
      },
      liningPrices: {
        DEFAULT: 20
      },
      id: '12.mari-upc-2'
    }, {
      name: 'Séparation haut / bas',
      prices: {
        DEFAULT: {
          min: 100,
          max: 130
        }
      },
      liningPrices: {
        DEFAULT: 25
      },
      id: '12.mari-upc-3'
    }, {
      name: 'Cintrer d’une taille ou plus',
      prices: {
        DEFAULT: {
          min: 65,
          max: 80
        }
      },
      liningPrices: {
        DEFAULT: 15
      },
      id: '12.mari-upc-4'
    }]
  }, {
    name: 'Manches / Épaules',
    slug: 'sleeves_upcycling',
    items: [{
      name: 'Ajout ornements manches',
      prices: {
        DEFAULT: {
          min: 80,
          max: 100
        }
      },
      id: '12.mari-upc-5'
    }, {
      name: 'Création de manches',
      prices: {
        DEFAULT: {
          min: 110,
          max: 140
        }
      },
      liningPrices: {
        DEFAULT: 30
      },
      id: '12.mari-upc-6'
    }, {
      name: 'Structuration des épaules',
      prices: {
        DEFAULT: {
          min: 110,
          max: 150
        }
      },
      liningPrices: {
        DEFAULT: 25
      },
      id: '12.mari-upc-7'
    }]
  }, {
    name: 'Col',
    slug: 'col_upcycling',
    items: [{
      name: 'Revue du design de l’encolure',
      prices: {
        DEFAULT: {
          min: 110,
          max: 150
        }
      },
      id: '12.mari-upc-8'
    }, {
      name: 'Création de col',
      prices: {
        DEFAULT: {
          min: 140,
          max: 170
        }
      },
      id: '12.mari-upc-9'
    }]
  }, {
    name: 'Bas de robe / jupe',
    slug: 'bottom_upcycling',
    items: [{
      name: 'Transfo > Pantalon',
      prices: {
        DEFAULT: {
          min: 170,
          max: 220
        }
      },
      liningPrices: {
        DEFAULT: 25
      },
      id: '12.mari-upc-10'
    }, {
      ref: '12.mari-upc-3'
    }]
  }, {
    name: 'Robe globale',
    slug: 'mari_upcycling',
    items: [{
      name: 'Cintrer d’une taille intégralement ou plus',
      prices: {
        DEFAULT: {
          min: 200,
          max: 250
        }
      },
      liningPrices: {
        DEFAULT: 50
      },
      id: '12.mari-upc-11'
    }, {
      name: 'Rigidification : donner de la tenue',
      prices: {
        DEFAULT: {
          min: 90,
          max: 120
        }
      },
      liningPrices: {
        DEFAULT: 25
      },
      id: '12.mari-upc-12'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'mari',
    name: variousPricingsName,
    categorySlug: 'upc',
    type: 'mari',
    minIndex: 12,
    slug: 'divers_upcycling'
  })]
}, {
  name: 'Combinaison',
  slug: 'comb',
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Tailleur'
  }],
  categories: [{
    name: 'Bustier / Taille',
    slug: 'bustier_upcycling',
    items: [{
      name: 'Ouverture dos',
      prices: {
        SIMPLE: {
          min: 15,
          max: 20
        },
        COMPLEX: {
          min: 20,
          max: 30
        }
      },
      liningPrices: {
        SIMPLE: 6,
        COMPLEX: 8
      },
      id: '12.comb-upc-1'
    }, {
      name: 'Décolleté',
      prices: {
        SIMPLE: {
          min: 50,
          max: 65
        },
        COMPLEX: {
          min: 65,
          max: 80
        }
      },
      liningPrices: {
        SIMPLE: 8,
        COMPLEX: 10
      },
      id: '12.comb-upc-2'
    }, {
      name: 'Séparation haut / bas',
      prices: {
        SIMPLE: {
          min: 50,
          max: 60
        },
        COMPLEX: {
          min: 60,
          max: 70
        }
      },
      liningPrices: {
        SIMPLE: 8,
        COMPLEX: 10
      },
      id: '12.comb-upc-3'
    }]
  }, {
    name: 'Manches / Épaules',
    slug: 'sleeves_upcycling',
    items: [{
      name: 'Ajout ornements manches',
      prices: {
        SIMPLE: {
          min: 40,
          max: 50
        },
        COMPLEX: {
          min: 50,
          max: 60
        }
      },
      id: '12.comb-upc-4'
    }, {
      name: 'Création de manches',
      prices: {
        SIMPLE: {
          min: 80,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 130
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.comb-upc-5'
    }, {
      name: 'Structuration des épaules',
      prices: {
        SIMPLE: {
          min: 70,
          max: 85
        },
        COMPLEX: {
          min: 85,
          max: 100
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.comb-upc-6'
    }]
  }, {
    name: 'Col',
    slug: 'col_upcycling',
    items: [{
      name: 'Revue du design de l’encolure',
      prices: {
        SIMPLE: {
          min: 80,
          max: 95
        },
        COMPLEX: {
          min: 95,
          max: 110
        }
      },
      id: '12.comb-upc-7'
    }, {
      name: 'Création de col',
      prices: {
        SIMPLE: {
          min: 70,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 140
        }
      },
      id: '12.comb-upc-8'
    }]
  }, {
    name: 'Bas de combinaison (jupe ou pantalon)',
    slug: 'bottom_upcycling',
    items: [{
      name: 'Transfo Jupe > Pantalon',
      prices: {
        SIMPLE: {
          min: 60,
          max: 90
        },
        COMPLEX: {
          min: 100,
          max: 150
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '12.comb-upc-9'
    }, {
      ref: '12.comb-upc-3'
    }]
  }, {
    name: 'Combinaison globale',
    slug: 'comb_upcycling',
    items: [{
      name: 'Cintrer d’une taille intégralement ou plus',
      prices: {
        SIMPLE: {
          min: 90,
          max: 120
        },
        COMPLEX: {
          min: 130,
          max: 180
        }
      },
      liningPrices: {
        SIMPLE: 30,
        COMPLEX: 50
      },
      id: '12.comb-upc-10'
    }, {
      name: 'Rigidification : donner de la tenue',
      prices: {
        SIMPLE: {
          min: 50,
          max: 70
        },
        COMPLEX: {
          min: 70,
          max: 90
        }
      },
      liningPrices: {
        SIMPLE: 10,
        COMPLEX: 15
      },
      id: '12.comb-upc-11'
    }, {
      ref: '12.comb-upc-3'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'comb',
    name: variousPricingsName,
    categorySlug: 'upc',
    minIndex: 11,
    slug: 'divers_upcycling'
  })]
}, {
  name: 'Pull & gilet',
  slug: 'pull',
  types: [{
    slug: 'SIMPLE',
    name: 'Basique'
  }, {
    slug: 'COMPLEX',
    name: 'Laine & cachemire'
  }],
  categories: [{
    name: 'Bustier / Taille',
    slug: 'bustier_upcycling',
    items: [{
      name: 'Ouverture dos',
      prices: {
        SIMPLE: {
          min: 15,
          max: 20
        },
        COMPLEX: {
          min: 20,
          max: 30
        }
      },
      liningPrices: {
        SIMPLE: 6,
        COMPLEX: 8
      },
      id: '10.pull-upc-1'
    }, {
      name: 'Décolleté',
      prices: {
        SIMPLE: {
          min: 50,
          max: 65
        },
        COMPLEX: {
          min: 65,
          max: 80
        }
      },
      liningPrices: {
        SIMPLE: 8,
        COMPLEX: 10
      },
      id: '10.pull-upc-2'
    }]
  }, {
    name: 'Manches / Épaules',
    slug: 'sleeves_upcycling',
    items: [{
      name: 'Ajout ornements manches',
      prices: {
        SIMPLE: {
          min: 40,
          max: 50
        },
        COMPLEX: {
          min: 50,
          max: 60
        }
      },
      id: '10.pull-upc-3'
    }, {
      name: 'Création de manches',
      prices: {
        SIMPLE: {
          min: 80,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 130
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '10.pull-upc-4'
    }, {
      name: 'Structuration des épaules',
      prices: {
        SIMPLE: {
          min: 70,
          max: 85
        },
        COMPLEX: {
          min: 85,
          max: 100
        }
      },
      liningPrices: {
        SIMPLE: 15,
        COMPLEX: 25
      },
      id: '10.pull-upc-5'
    }]
  }, {
    name: 'Col',
    slug: 'col_upcycling',
    items: [{
      name: 'Revue du design de l’encolure',
      prices: {
        SIMPLE: {
          min: 80,
          max: 95
        },
        COMPLEX: {
          min: 95,
          max: 110
        }
      },
      id: '10.pull-upc-6'
    }, {
      name: 'Création de col',
      prices: {
        SIMPLE: {
          min: 70,
          max: 100
        },
        COMPLEX: {
          min: 100,
          max: 140
        }
      },
      id: '10.pull-upc-7'
    }]
  }, (0, _commonPricings.getVariousPricingsCategory)({
    pieceSlug: 'pull',
    name: variousPricingsName,
    categorySlug: 'upc',
    minIndex: 9,
    slug: 'divers_upcycling'
  })]
}];
var upcyclingPricing = rawUpcyclingPricing.map(function (cloth) {
  return _objectSpread(_objectSpread({}, cloth), {}, {
    categories: cloth.categories.map(function (category) {
      return _objectSpread(_objectSpread({}, category), {}, {
        items: category.items.map(function (item) {
          var _item$prices, _item$prices$SIMPLE, _item$prices2, _item$prices2$COMPLEX, _item$prices3, _item$prices3$DEFAULT;
          return _objectSpread(_objectSpread({}, item), {}, {
            hasPriceRange: !!((_item$prices = item.prices) !== null && _item$prices !== void 0 && (_item$prices$SIMPLE = _item$prices.SIMPLE) !== null && _item$prices$SIMPLE !== void 0 && _item$prices$SIMPLE.min) || !!((_item$prices2 = item.prices) !== null && _item$prices2 !== void 0 && (_item$prices2$COMPLEX = _item$prices2.COMPLEX) !== null && _item$prices2$COMPLEX !== void 0 && _item$prices2$COMPLEX.min) || !!((_item$prices3 = item.prices) !== null && _item$prices3 !== void 0 && (_item$prices3$DEFAULT = _item$prices3.DEFAULT) !== null && _item$prices3$DEFAULT !== void 0 && _item$prices3$DEFAULT.min)
          });
        })
      });
    })
  });
});
function getUpcyclingInverse(baseUpcyclingPricing) {
  var inverse = {};
  baseUpcyclingPricing.forEach(function (cloth) {
    return cloth.categories.forEach(function (category) {
      return category.items.filter(function (_ref) {
        var ref = _ref.ref;
        return !ref;
      }).forEach(function (item) {
        if (inverse[item.id]) {
          throw new Error("Inverse pricing, duplicate key : ".concat(item.id));
        }
        inverse[item.id] = _objectSpread(_objectSpread({}, item), {}, {
          cloth: cloth.name,
          category: category.name
        });
      });
    });
  });
  return inverse;
}
var upcyclingPricingInverse = exports.upcyclingPricingInverse = getUpcyclingInverse(upcyclingPricing);
var _default = exports["default"] = upcyclingPricing;